/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2013, 2016
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 * @module /dashboard/data/Events
 * @see Events
 */

define(['./Class'], function (Class) {
	'use strict';

	/**
  * Events implements the Backbone-style eventing model objects
  *
  * @class Events
  */

	var Events = Class.extend({
		init: function init() {
			this._events = {};
		},

		/**
   * The 'on' method registers the handler and return DOJO-style event registration object with 'remove' method, which unregisters the handler.
   *
   * This implementation supports composite event names, such as 'eventBaseName:eventSecondaryName', for example: 'change:name'. Triggering 'change:name' event would invoke handlers registered to
   * listen 'change' event as well as the handlers registered to listen the 'change:name' event. The special event name 'all' can be used to listen to all event types.
   */
		on: function on(eventName, handler, context) {
			if (typeof handler !== 'function') {
				console.log('ERROR in Events.on: Invalid event handler');
			}
			if (!this._events[eventName]) {
				this._events[eventName] = [];
			}
			this._events[eventName].push({
				handler: handler,
				context: context
			});

			var that = this;
			return {
				remove: function remove() {
					that.off(eventName, handler, context);
				}
			};
		},

		/**
   * Removes the specified handler from the listening to the events on this object. If eventName is not specified then unregister handler and context for all event types. If handler is not specified
   * then unregister all event handlers for the specified context and event name. If context is not specified then unregister all event handlers for the specified handler and event name.
   *
   * Examples: obj.off('change:name', handler, context); // unregister handler in context from listening 'change:name' event obj.off(null, null, context); // unregister all event handlers for the
   * specified context obj.off(); // unregister all event handlers
   */
		off: function off(eventName, handler, context) {
			var getEvents = function getEvents(evName, self) {
				var events = self._events;
				if (!evName) {
					return events;
				}
				var parts = evName.split(':');
				events = {};
				events[parts[0]] = self._events[parts[0]];
				if (parts.length > 1 && parts[1] !== '*') {
					events[evName] = self._events[evName];
				} else if (parts.length > 1 && parts[1] === '*') {
					for (var name in self._events) {
						if (name.indexOf(parts[0] + ':') === 0) {
							events[name] = self._events[name];
						}
					}
				}
				return events;
			};
			var events = getEvents(eventName, this);

			for (var name in events) {
				var i = 0,
				    handlers = events[name];
				if (!handlers) {
					continue;
				}
				while (i < handlers.length) {
					if ((handlers[i].handler === handler || !handler) && (handlers[i].context === context || !context)) {
						handlers.splice(i, 1);
					} else {
						i++;
					}
				}
			}
		},

		/**
   * Triggers an event
   */
		trigger: function trigger(eventName, event) {
			var parts = eventName.split(':');
			var handlers = [].concat(this._events['all'] || []).concat(this._events[parts[0]] || []);
			if (parts.length > 1) {
				handlers = handlers.concat(this._events[eventName] || []);
			}
			for (var i = 0; i < handlers.length; i++) {
				if (typeof handlers[i].handler === 'function') {
					handlers[i].handler.call(handlers[i].context, event, eventName);
				}
			}
		}
	});

	// alias
	Events.prototype.emit = Events.prototype.trigger;

	//
	return Events;
});
//# sourceMappingURL=Events.js.map



// WEBPACK FOOTER //
// ./src/js/lib/@waca/core-client/js/core-client/ui/core/Events.js